var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("\n    業種:\n    "+_vm._s(_vm.type)+"\n  ")]),_c('div',[_vm._v("\n    業者:\n    "+_vm._s(_vm.name)+"\n  ")]),_c('div',[_vm._v("\n    作業者:\n    "+_vm._s(_vm.staffName)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }